import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

import { AngularFireDatabase} from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';


@Component({
  selector: 'app-spot-detail',
  templateUrl: './spot-detail.component.html',
  styleUrls: ['./spot-detail.component.css']
})
export class SpotDetailComponent implements OnInit {

  lat: number = 51.678418;
  lng: number = 7.809007;

  id: number;
  private sub: any;

  items: Observable<any[]>;

  constructor(private route: ActivatedRoute, private db: AngularFireDatabase, public router: Router) {

  }

  ngOnInit() {

    this.sub = this.route.params.subscribe(params => {
      this.id = params['id']; // (+) converts string 'id' to a number
      console.log("Die id " + this.id);

      this.items = this.db.list('/study_spot', ref => ref.orderByChild('objectId').equalTo(this.id)).valueChanges();

    });

  }

  back() {
    this.router.navigate(['/home/']);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/spot-detail/spot-detail.component.ts